import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Handle, Position, useReactFlow } from "reactflow";
import FlagIcon from '@mui/icons-material/Flag';
import { i18n } from "../../../translate/i18n";
import { HandleConexaBot } from "../handle";
import { useState } from "react";
import { INode } from "../manager";
import classNames from "classnames";
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Theme } from '@mui/material/styles';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const useStyles = makeStyles((theme: Theme) => createStyles({
  messageOptions: {
    width: 'fit-content',
    display: 'inline-block',
    borderRadius: '20px',
    marginTop: '2px',
    backgroundColor: '#616161',
    transition: 'opacity 0.3s ease',
    '& svg': {
      color: "#ffffff",
    },
  },
}));

export const StartNode = ({ data }: any) => {

    const classes = useStyles();
    const { id } = data as INode["data"];
    const [isHovered, setIsHovered] = useState(false);

    const { setNodes, setEdges } = useReactFlow();

    const handleDelete = () => {
        // remove node
        setNodes((nodes) => nodes.filter((n) => n.id !== id));
        // remove edges ligados a ele
        setEdges((edges) => edges.filter((e) => e.source !== id && e.target !== id));
    };

    const renderMessageOptions = () => {
        return (
            <Box
                className={classNames({
                    [classes.messageOptions]: true,
                })}
                sx={{
                    opacity: isHovered == true ? '1' : '0',
                    position: "absolute",
                    right: "10px"
                }}
            >
                {/* <Tooltip
                    title={i18n.t("buttons.delete")}
                >
                    <IconButton
                        size="small"
                        onClick={handleDelete}
                        id={`button-node-${id}`}
                        key={`button-node-${id}`}
                        sx={{
                            background: (theme) => theme.palette.mode === "dark" ? "#f44336" : "#ef5350",
                            width: "20px",
                            height: "20px",
                            "& svg": {
                                width: "12px",
                                height: "12px"
                            },
                            "&:hover": {
                                background: (theme) =>
                                    theme.palette.mode === "dark" ? "#f44336" : "#ef5350",
                            },
                        }}
                    >
                        <DeleteOutlineOutlinedIcon />
                    </IconButton>
                </Tooltip> */}
            </Box>
        );
    }

    return (
        <Box
            sx={{
                borderRadius: '3px',
                border: '1px solid',
                padding: '0px',
                minWidth: 120,
                borderColor: '#757575',
                background: '#eeeeee',
                color: (theme) => theme.palette.mode == 'dark' ? '#757575' : '#424242',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    background: "#545454",
                    color: (theme) => theme.palette.mode == "dark" ? "#4fc3f7" : "#ffffff",
                    fontSize: "0.65rem",
                    borderTopLeftRadius: "2px",
                    borderTopRightRadius: "2px",
                    padding: "5px",
                    borderBottom: "1px solid #6B6B6B"
                }}
            >
                <FlagIcon
                    sx={{
                        width: "15px",
                        height: "15px",
                    }}
                />
                {i18n.t("conexaBots.nodes.start.title")}
                {renderMessageOptions()}
            </Box>
            <Typography
                component="p"
                sx={{
                    fontSize: "0.5rem",
                    padding: "5px 10px"
                }}
            >
                {i18n.t("conexaBots.nodes.start.message")}
            </Typography>
            <HandleConexaBot type="source" subtype="start" id={`${id}-source`} />
        </Box>
    )
}